export const css = {
    root: '_1WKLuBYr',
    content: '_1b0WyW-u',
    loading: '_1snAqKaO',
    promote: 'WSmEK70v',
    disabledPromote: '_28Mu1qcL',
    domain: 'JA__xPXW',
    title: '_19mdR43b',
    subtitle: '_1w1WYNLu',
    actions: '_19OTnx59',
    indicator: '_1nRro2-Z',
    ' _key': 'certwise-theme/certwise/card/tgf'
};
export default css;
